import { useState } from "react";
import Axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import {
  User,
  Mail,
  Lock,
  Eye,
  EyeOff,
  AlertCircle,
  CheckCircle,
  Loader2,
} from "lucide-react";
import loginimg from "../images/logo.jpg";
import "../css/signup.css"; // Importe o CSS novo
import imgFundo from "../images/Guaratingueta.png";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");

  // Estados de controle visual
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const navigate = useNavigate();

  const register = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" }); // Limpa mensagens anteriores

    Axios.post("/api/register", {
      email: email,
      name: name,
      password: password,
    })
      .then((response) => {
        if (response.data.message) {
          // O backend retornou uma mensagem específica (ex: email já existe)
          setStatus({ type: "error", message: response.data.message });
        } else {
          // Sucesso
          setStatus({ type: "success", message: "Conta criada com sucesso!" });
          // Redireciona após 1.5 segundos
          setTimeout(() => navigate("/login"), 1500);
        }
      })
      .catch((error) => {
        console.error("Erro no registro:", error);
        setStatus({
          type: "error",
          message: "Erro ao conectar com o servidor.",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="signup-container"
        style={{backgroundImage:`url(${imgFundo})`}}>
      <div className="signup-card">
        {/* Logo */}
        <div className="text-center">
          <img src={loginimg} alt="Logo" className="brand-logo" />
        </div>

        <h1 className="signup-title">Crie sua conta</h1>
        <p className="signup-subtitle">Preencha os dados abaixo para começar</p>

        {/* Mensagens de Erro/Sucesso */}
        {status.message && (
          <div
            className={`alert-box ${status.type === "error" ? "alert-error" : "alert-success"}`}
          >
            {status.type === "error" ? (
              <AlertCircle size={18} />
            ) : (
              <CheckCircle size={18} />
            )}
            <span>{status.message}</span>
          </div>
        )}

        <form onSubmit={register}>
          {/* Input Nome */}
          <div className="input-group-clean">
            <User size={20} className="input-icon" />
            <input
              type="text"
              className="form-input"
              placeholder="Nome completo"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* Input Email */}
          <div className="input-group-clean">
            <Mail size={20} className="input-icon" />
            <input
              type="email"
              className="form-input"
              placeholder="Seu melhor e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* Input Senha */}
          <div className="input-group-clean">
            <Lock size={20} className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              className="form-input"
              placeholder="Crie uma senha forte"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex="-1"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? (
              <>
                <Loader2 size={20} className="animate-spin me-2" />
                Criando conta...
              </>
            ) : (
              "Cadastrar"
            )}
          </button>

          <div className="login-link">
            Já possui uma conta? <Link to="/login">Fazer Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
